export default __webpack_public_path__ + "static/media/afr_logo.d4931f84.png";